var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.3335C5.05935 1.3335 2.66668 3.72616 2.66668 6.6635C2.64735 10.9602 7.79735 14.5228 8.00001 14.6668C8.00001 14.6668 13.3527 10.9602 13.3333 6.66683C13.3333 3.72616 10.9407 1.3335 8.00001 1.3335ZM8.00001 9.3335C6.52668 9.3335 5.33335 8.14016 5.33335 6.66683C5.33335 5.1935 6.52668 4.00016 8.00001 4.00016C9.47335 4.00016 10.6667 5.1935 10.6667 6.66683C10.6667 8.14016 9.47335 9.3335 8.00001 9.3335Z",
    fill: "#2B2D42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.263adf66857909185706e553aee3ca29.svg";
export { ForwardRef as ReactComponent };